export default {"src":"/_next/static/media/favicon.bb6960ae.svg","height":512,"width":512};